import type { RouteRecordRaw } from 'vue-router';

export const readerRoute: RouteRecordRaw = {
  path: '/text-bible',
  name: 'TextBible',
  component: () => import('./pages/ReaderPage.vue'),
  meta: { depth: 1 },
};
